export { PartnersBanner } from './PartnersBanner';
